import { storage } from '../../auth/utils';

class LeftNavController {
  constructor(AuthService, $scope, $state, $rootScope, Products) {
    'ngInject';

    this.AuthService = AuthService;
    this.Products = Products;
    this.$state = $state;
    this.user = AuthService.user;
    this.account = $rootScope.account;
    this.FeatureFlags = this.account.feature_flags;
    this.canEditBoxcaster = $rootScope.user.can('update', 'boxcaster/*');
    this.canEditChannel = $rootScope.user.can('update', 'channel/*');
    this.canUpload = $rootScope.user.can('create', 'upload');
    this.canAccessReports = $rootScope.user.can('read', 'viewer-analytics/*');
    this.canScheduleBroadcast = $rootScope.user.can('create', 'broadcast');
    this.canEmbed = $rootScope.user.can('embed', 'broadcast/*');
    this.canUpgrade = $rootScope.user.can('create', 'upgrade');
    this.currentYear = new Date().getFullYear();
    this.switchAccount = (a) => $rootScope.$emit('user:switchAccount', a);
    this.allowProducer = $rootScope.user.can('create', 'broadcast') && this.FeatureFlags.producer;
    this.uploadsRoute =
      $rootScope.user.can('create', 'broadcast') &&
      $rootScope.user.can('create', 'broadcast/*:upload')
        ? $rootScope.vueDashboardRoot + '/uploads'
        : $rootScope.vueDashboardRoot + '/uploads/thumbnail-images';

    this.canAccessSharing = $rootScope.user.can('list', 'clips') && this.FeatureFlags.clips;
    this.canAccessPosts = $rootScope.user.can('list', 'posts') && this.FeatureFlags.clips;
  }

  openGrowSurf() {
    console.log('open growsurf');
    if (window.growsurf.getParticipantId()) {
      window.growsurf.init({ email: this.user.email, hash: window.growsurf.getCampaign() });
      window.growsurf.open();
    } else {
      const name = this.user.name.split(' ');
      window.growsurf.addParticipant({
        email: this.user.email,
        firstName: name[0],
        lastName: name[1],
      });
      window.growsurf.open();
    }
  }

  logout() {
    this.$state.go('logout');
  }
}

export default LeftNavController;



// WEBPACK FOOTER //
// ./app/pages/navbar/left-navbar.js